var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "SeachableList",
    {
      attrs: {
        emptyListTitle:
          "You are not yet connected to any companies. Once you are in a companies database, their profile will appear here.",
        emptySearchResultTitle: "No companies found for your request",
        listItems: _vm.companies,
        loading: _vm.$apollo.loading,
        total: _vm.paginationConfig.total,
        outsdeSearchTouched: _vm.searchTouched,
      },
      scopedSlots: _vm._u([
        {
          key: "filtersFullBlock",
          fn: function () {
            return [_c("SearchOnAction", { on: { search: _vm.onSearch } })]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._l(_vm.companies, function (company) {
        return _c("CompanyCard", {
          key: company.id,
          attrs: {
            address1: company.address1,
            address2: company.address2,
            city: company.city,
            companyName: company.business_name,
            country: company.country,
            description: company.description,
            industry: company.industry,
            phoneNumber: company.phone_number,
            postalCode: company.postal_code,
            state: company.state,
            website: company.website,
            disabledNotifications: company.users_disabled_notifications,
            companyId: company.id,
            avatar: company.company_logo,
            currentUserId: _vm.currentUser.id,
          },
          on: { message: () => _vm.message(company) },
        })
      }),
      _c("CardPagination", {
        attrs: { config: _vm.paginationConfig },
        on: {
          "update:config": function ($event) {
            _vm.paginationConfig = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }